<template>
    <div id="listRate">
        <div :class="`loader${loaderClass}`" v-show="loading">

        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="container-fluid xyz">
                    <div class="page-name">Bounce Email Report
                       <data-table-column-config :moduleName="'bounceEmailReportsList'"></data-table-column-config>
                    </div>
                    <!--page content-->
                    <div class="admin-page-content customer-detail">
                        <data-table-filter-config :moduleName="'bounceEmailReports'" @cancelSelection="cancelAll"></data-table-filter-config>
                        <section class="internal-container">
                            <div class="container">
                                <vue-good-table
                                        ref="listEmailReport"
                                        mode="remote"
                                        @on-page-change="onPageChange"
                                        @on-sort-change="onSortChange"
                                        @on-column-filter="onColumnFilter"
                                        @on-per-page-change="onPerPageChange"
                                        :totalRows="totalRecords"
                                        title="Emails"
                                        :columns="userColumns"
                                        :rows="rows"
                                        :paginate="true"

                                        :paginationOptions="{
                                            enabled: true,
                                            position: 'both',
                                            perPage: 50,
                                            dropdownAllowAll: false,
                                        }"
                                        :select-options="{
                                        enabled: emailReport,
                                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                        selectionInfoClass: 'custom-class',
                                        selectionText: 'rows selected',
                                        clearSelectionText: 'clear',
                                    }"
                                        :sort-options="{
                                            enabled: true,
                                        }"
                                    >
                                    <!-- <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'" class='btn-center-vvg'>
                                                <template v-if="permission.name == 'list_courtesy_notice'" v-for="(permission, index) in permissions">
                                                    <a href="javascript:void(0)" title="View" v-bind:key="'action' + index" class="glyphicon glyphicon-eye-open" v-on:click="viewMailTemplate(props.row.id)"></a>
                                                </template>
                                            </div>
                                            <div v-else>
                                                <span v-fp-html="props.formattedRow[props.column.field]"></span>
                                            </div>
                                        </div>
                                    </template> -->
                                    <div slot="selected-row-actions">
                                        <button id="send" v-on:click.prevent="cancelEmail()" class="btn btn-success waves-effect">Delete</button>
                                    </div>
                                </vue-good-table>
                            </div>
                        </section>
                    </div>
                    <div class="modal fade invoice-modal" id="invoice_modal" ref="invModal" data-backdrop="static" data-keyboard="false" aria-labelledby="invModal" aria-hidden="true">

                        <div :class="`loader${loaderClass}`" v-show="modalLoading"></div>
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content notice-modal">
                                <div class="modal-header">
                                    <h5 class="modal-title">Email Content</h5>
                                    <h5 style="float:right;" id='sent_date'></h5>
                                </div>
                                <p>&nbsp;</p>
                                <div class="mailBody">
                                    TO: &nbsp;<span id='toMail'></span><br>
                                    CC: &nbsp;<span id="ccMail"></span>
                                </div>
                                <div class="modal-body">

                                </div>
                                <div class="modal-footer">
                                    <!--<button class="btn btn-primary" id="download_inv_btn" v-on:click="viewInvoice(BookData.bookingId,'download')">Download</button>-->
                                    <button type="button" class="btn btn-primary" data-dismiss="modal">Cancel</button>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>

<script>
    import Vue from 'vue';






    import {commonMixins} from '../mixins/commonMixins';
    import {dataTableMixins} from '../mixins/dataTableMixins';

    export default {
        name: "sentemail",
        mixins:[commonMixins,dataTableMixins],
        data: () => ({
             permissions: [],
            cantAccessPage: "",
            firstLoad : 0,
            userColumns:[],
            emailReport:true,
            columns: [
                {
                    label: 'Email',
                    field: 'email',
                    filterable: true,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Sent To", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Status',
                    field: 'status',
                    fpFieldType:"option",
                    html: false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Status", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Block','Unblock'], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Date',
                    field: 'created_at',
                    fpFieldType:"date",
                    html: false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },

                // {
                //     label: 'Action',
                //     field: 'action',
                //     sortable: false,
                // },

            ],
            rows: [],
            totalRecords: 0,
            serverParams: {
                columnFilters: {
                },
                sort: {
                    field: 'updated_at',
                    type: 'desc',
                },
                page: 1,
                perPage: 50
            },
            loading:false,
            modalLoading:false,
        }),
        watch: {
            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_user') {
                            self.cantAccessPage = true;
                        }
                    }
                }

            }
        },
        mounted: function () {

            var self = this;

            self.getPermissions();

        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listEmailReport.unselectAllInternal();
            },
            // updateParams(newProps) {
            //     this.serverParams = Object.assign({}, this.serverParams, newProps);
            // },
            // onPageChange(params) {
            //     this.updateParams({page: params.currentPage});
            //     this.loadEmailReport();
            // },
            // onPerPageChange(params) {
            //     this.updateParams({perPage: params.currentPerPage});
            //     this.totalRecords = self.totalRecords;
            //     this.loadEmailReport();
            // },

            // onColumnFilter(params) {
            //     this.updateParams(params);
            //     {
            //         field:('sent_to');
            //         field:('email');
            //         field:('type');
            //         field:('status');
            //         field:('updated_at');
            //         field:('created_by');
            //     };
            //     var filtersPr = JSON.parse(JSON.stringify(this.serverParams));
            //     var filters = filtersPr.columnFilters;
            //     if (this.firstLoad == 1 || filters.sent_to || filters.email || filters.type || filters.status || filters.updated_at || filters.created_by ) {
            //         this.loadEmailReport();
            //     }
            // },
            // selectionChanged() {
            //     var self = this;
            //     // console.log(self.computed.selectedRows);
            //     // var rowData = self.$refs['my-table'].selectedRows;
            //     // console.log(rowData);
            // },
            // onSortChange(params) {
            //     this.updateParams({
            //         sort: {
            //             type: params[0].type,
            //             field: params[0].field,
            //         },
            //     });
            //     this.loadEmailReport();
            // },

            loadList(){

                var self = this;
                self.loading = true;
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/report/bounce-emails",
                    type: "GET",
                    crossDomain: true,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    data:{
                        page: self.serverParams.page,
                        perPage: self.serverParams.perPage,
                        filters: self.serverParams.columnFilters,
                        sort: self.serverParams.sort,
                    },
                    success: function (data) {
                        self.loading = false;
                        //console.log(data.content[0]["id"]);
                        // if (data.status == "success") {
                            self.rows = data.row;

                            // self.perPage = data.content.perPage;
                            // if (data.content.totalRecords == 0){
                            //     self.rows = 0;
                            // }
                            self.totalRecords = data.totalRecords;

                        // }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.error = "Remote server cannot be reached";
                        } else {

                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('tkn');

                                self.$router.push("/");
                            }

                            self.error = jqXHR.responseJSON.message;

                        }

                    }
                });
            },

            cancelEmail() {
                var data = this.$refs['listEmailReport'].selectedRows;
                var self = this;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(this.$refs['listEmailReport'].selectedRows[i].id)
                }

                if (confirm('Are you sure that you want to delete it? ')) {
                    self.loading = true;
                    $.ajax({
                        url: process.env.ROOT_API + "/email-report/delete",
                        type: "POST",
                        data: 'ids=' + use,
                        headers: this.ajxHeaders,
                        dataType: 'json',
                        success: function (data) {
                            self.loading = false;

                            self.rows = data.content.row;

                            self.loadList();

                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            if (jqXHR.status == 0) {
                                self.error = "Remote server cannot be reached";
                            } else {
                                //redirect to login page if user not authenticated
                                if (jqXHR.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem('user_obj');
                                    localStorage.removeItem('tkn');

                                    self.$router.push("/");
                                }
                               self.error = jqXHR.responseJSON.message;
                            }
                        }
                    });
                }
            }
        }
    };
</script>
<style scoped>

.mailBody{
    margin-left: 6%;
}
</style>




// WEBPACK FOOTER //
// src/components/BounceEmail.vue